module.exports = __webpack_public_path__ + "static/media/Stare_hory.2a2bf670.md";